import React, { FC } from 'react';
import { ActionsButtonProps } from './EditModalInterface';
import { ActionButtonContainer, ActionButtonStyled } from './styled';

const ActionsButton: FC<ActionsButtonProps> = ({
    handleClickConfirm,
    labelConfirm,
}) => (
    <ActionButtonContainer>
        <ActionButtonStyled
            onClick={handleClickConfirm}
            variant="text"
            default
            disableRipple
        >
            {labelConfirm}
        </ActionButtonStyled>
    </ActionButtonContainer>
);

export default ActionsButton;
